import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useMaincategory, useMainAllcategory } from "../../actions/homeActions";
import {
  useUpdateTalent,
  useTalentMutation,
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
import textWeight from "../../utils/textWeight";
export default () => { 
  const navigate = useNavigate();
  const { TextWeight } = textWeight();
  const userData = useSelector((state) => state.app.userData.userData);
  const [countryCode, setCountryCode] = useState(null);
  const [cca2, setCca2] = useState(null);
  const [activeTab, setActiveTab] = useState("personalInformation");
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [links, setLinks] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [linksErrors, setLinksErrors] = useState({ platform: "", links: {} });
  const { data: desiredJobType, isLoading: desiredJobTypeIsloading } =
    useMainAllcategory("main"); //useMaincategory("main");
  const { data: talentData, isLoading: isLoadingprefilled } = useUpdateTalent(
    userData?.talent?.id
  );
  const { data: dropdowns, isLoading, isError, error } = useDropdown();

  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      stage_name: talentData?.stage_name || "",
      real_name: talentData?.real_name || "",
      age: talentData?.age ? String(talentData?.age) : "",
      gender: talentData?.gender?.gender_id
        ? String(talentData?.gender?.gender_id)
        : "",
      ethinicity: talentData?.ethnicity?.ethnicity_id
        ? String(talentData?.ethnicity?.ethnicity_id)
        : "",
      city_id: talentData?.city_id || "",
      countries: talentData?.country_id ? String(talentData?.country_id) : "",
      state_id: talentData?.state?.state_id
        ? String(talentData?.state?.state_id)
        : "",
      home_phone: talentData?.home_phone || "",
      mobile_number: talentData?.mobile_number || "",
      your_website: talentData?.your_website
        ? String(talentData?.your_website)
        : "",
      hairTypes: talentData?.hair_type?.hair_type_id
        ? String(talentData?.hair_type?.hair_type_id)
        : "",
      height: talentData?.height || "",
      weight: talentData?.weight || "",
      eye_colors: talentData?.eye_color?.eye_color_id
        ? String(talentData?.eye_color?.eye_color_id)
        : "",
      bodyTattoos: talentData?.tattoos,
      bodyPiercings: talentData?.piercings,
      // sexualOrientations: talentData?.sexual_orientation?.sexual_orientation_id ? String(talentData?.sexual_orientation?.sexual_orientation_id) : '',
      experience: talentData?.experience_level?.job_experience_id
        ? String(talentData?.experience_level?.job_experience_id)
        : "",
      otherExperience: "",
      qualification: talentData?.qualification || "",
      agent_code: talentData?.agent_code ? String(talentData?.agent_code) : "",
      about_me: talentData?.about_me ? String(talentData?.about_me) : "",
      desired_job_types: Array.isArray(talentData?.desired_job_types)
        ? talentData?.desired_job_types.map((item) => item.id)
        : [],
      otherLanguage: "",
    },
  });

  const selectedCountry = watch("countries");
  const selectedState = watch("state_id");
  const { data: states, isLoading: isLoadingStates } =
    useStatesDropdowns(selectedCountry);
  const { data: cities, isLoading: citiesisLoading } =
    UsecitiesDropdowns(selectedState);
  useEffect(() => {
    if (
      !isLoadingprefilled &&
      talentData &&
      Object.keys(talentData).length > 0
    ) {
      setValue("stage_name", talentData?.stage_name || "");
      setValue("real_name", talentData?.real_name || "");
      setValue("age", talentData?.age ? String(talentData?.age) : "");
      setValue(
        "gender",
        talentData?.gender?.gender_id
          ? String(talentData?.gender?.gender_id)
          : ""
      );
      setValue(
        "ethinicity",
        talentData?.ethnicity?.ethnicity_id
          ? String(talentData?.ethnicity?.ethnicity_id)
          : ""
      );
      // setValue("city", talentData?.city || '');
      setValue(
        "city_id",
        talentData?.city_id ? String(talentData?.city_id) : ""
      );
      setValue(
        "countries",
        talentData?.country_id ? String(talentData?.country_id) : ""
      );
      setValue(
        "state_id",
        talentData?.state?.state_id ? String(talentData?.state?.state_id) : ""
      );
      setValue("home_phone", talentData?.home_phone || "");
      setValue("mobile_number", talentData?.mobile_number || "");
      setValue(
        "your_website",
        talentData?.your_website ? String(talentData?.your_website) : ""
      );
      setValue(
        "hairTypes",
        talentData?.hair_type?.hair_type_id
          ? String(talentData?.hair_type?.hair_type_id)
          : ""
      );
      setValue("height", talentData?.height || "");
      setValue("weight", talentData?.weight || "");
      setValue(
        "eye_colors",
        talentData?.eye_color?.eye_color_id
          ? String(talentData?.eye_color?.eye_color_id)
          : ""
      );
      setValue("bodyTattoos", talentData?.tattoos);
      setValue("bodyPiercings", talentData?.piercings);
      // setValue("sexualOrientations", talentData?.sexual_orientation?.sexual_orientation_id ? String(talentData?.sexual_orientation?.sexual_orientation_id) : '');
      setValue(
        "experience",
        talentData?.experience_level?.job_experience_id
          ? String(talentData?.experience_level?.job_experience_id)
          : ""
      );
      setValue("otherExperience", talentData?.other_experience || "");
      setValue("qualification", talentData?.qualification || "");
      setValue(
        "agent_code",
        talentData?.agent_code ? String(talentData?.agent_code) : ""
      );
      setValue(
        "about_me",
        talentData?.about_me ? String(talentData?.about_me) : ""
      );
      setValue(
        "desired_job_types",
        Array.isArray(talentData?.desired_job_types)
          ? talentData?.desired_job_types.map((item) => item.id)
          : []
      );
      setValue("otherLanguage", talentData?.other_language || "");
    }
    if (talentData?.social_media) {
      setLinks(
        talentData?.social_media?.map((item, i) => ({
          id: item.id ?? Date.now() + i,
          platform: item.social_media_type,
          url: item.social_media_link,
        }))
      );
    }
  }, [talentData, isLoadingprefilled, setValue]);

  const talentId = talentData?.id;
  const mutation = useTalentMutation(
    talentId,
    dispatch,
    setLoadingToapi,
    navigate
  );

  const addLink = () => {
    const platformExists = links.some(
      (link) => link.platform === selectedPlatform
    );

    if (!selectedPlatform) {
      setLinksErrors((prev) => ({
        ...prev,
        platform: "Please select a platform.",
      }));
      return;
    }

    if (platformExists) {
      setLinksErrors((prev) => ({
        ...prev,
        platform: `${selectedPlatform} is already added.`,
      }));
      return;
    }

    // Clear platform error when adding new
    setLinksErrors((prev) => ({ ...prev, platform: null }));

    setLinks([
      ...links,
      { id: Date.now(), platform: selectedPlatform, url: "" },
    ]);
    setSelectedPlatform("");
  };

  const updateLink = (id, url) => {
    setLinks((prev) =>
      prev.map((link) => (link.id === id ? { ...link, url } : link))
    );

    setLinksErrors((prev) => {
      const newErrors = { ...prev.links };
      if (!url.trim()) {
        newErrors[id] = "Link is required.";
      } else if (!isValidUrl(url)) {
        newErrors[id] = "Please enter a valid URL (with https:// and .com).";
      } else {
        delete newErrors[id]; // Remove error if valid
      }
      return { ...prev, links: newErrors };
    });
  };

  const removeLink = (id) => {
    setLinks((prev) => prev.filter((link) => link.id !== id));
    setLinksErrors((prev) => {
      const updatedErrors = { ...prev.links };
      delete updatedErrors[id];
      return { ...prev, links: updatedErrors };
    });
  };

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading talent: {error.message}</p>
      </div>
    );
  }
  const isValidUrl = (url) => {
    const pattern =
      /^https?:\/\/(www\.)?[\w\-]+\.(com|net|org|co|in|info|biz|me|us|uk)(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    return pattern.test(url);
  };

  const otherExperienceId = watch("experience");
  const otherLanguageId = watch("languages_spoken");
  const onSubmit = (data, e) => {
    e.preventDefault();
    setLoadingToapi(true);

    const userId = localStorage.getItem("userId");
    const apiData = new FormData();
    apiData.append("stage_name", data?.stage_name || talentData?.stage_name);
    apiData.append("real_name", data.real_name || talentData?.real_name);
    apiData.append("age", data.age || talentData?.age);
    apiData.append("gender", data.gender || talentData?.gender?.gender_id);
    apiData.append("ethinicity", data.ethinicity || talentData?.ethinicity);
    apiData.append("city_id", data.city_id || talentData?.city_id);
    apiData.append("country_id", data.countries || talentData?.country_id);
    apiData.append("country_code", countryCode || talentData?.country_code);
    apiData.append('cca2', cca2 || talentData?.cca2);  
    apiData.append("state_id", data.state_id || talentData?.state_id);
    apiData.append(
      "mobile_number",
      data.mobile_number || talentData?.mobile_number
    );
    apiData.append("your_website", data.your_website);
    if (talentData?.off_screen === 0) {
      apiData.append(
        "hair_type",
        data.hairTypes || talentData?.hair_type?.hair_type_id
      );
      apiData.append("height", data.height || talentData?.height);
      apiData.append("weight", data.weight || talentData?.weight?.weight);
      apiData.append(
        "eye_colors",
        data.eye_colors || talentData?.eye_color?.eye_color_id
      );
      apiData.append("bodyTattoos", data.bodyTattoos || talentData?.tattoos);
      apiData.append("bodyPiercings", data.piercings || talentData?.piercings);
    }
    // apiData.append('sexual_orientation', data.sexualOrientations || talentData?.sexual_orientation?.sexual_orientation_id);
    apiData.append(
      "experience_level",
      data.experience || talentData?.experience_level?.job_experience_id
    );
    if (data.experience == 52) {
      apiData.append("other_experience", data.otherExperience);
    }
    apiData.append(
      "qualification",
      data?.qualification || talentData?.qualification
    );
    apiData.append("agent_code", data?.agent_code);
    apiData.append("about_me", data?.about_me);
    if (data?.desired_job_types) {
      data.desired_job_types.forEach((jobType) => {
        apiData.append("desired_job_types[]", jobType);
      });
    } else {
      talentData?.desired_job_types?.forEach((jobType) => {
        apiData.append("desired_job_types[]", jobType?.id);
      });
    }

    if (data?.languages_spoken) {
      data.languages_spoken.forEach((language) => {
        apiData.append("language_spoken[]", language);
      });
    } else {
      talentData?.languages_spoken?.forEach((language) => {
        apiData.append("language_spoken[]", language?.id);
      });
    }

    apiData.append("other_language", data.otherLanguage);
    links.forEach((link) => {
      apiData.append("social_media_type[]", link.platform);
      apiData.append("social_media_link[]", link.url);
    });
    apiData.append("user_id", userId);
    apiData.append("off_screen", talentData?.off_screen);
    apiData.append("_method", "PUT");
    mutation.mutate(apiData);
  };

  const tabs = [
    { key: "personalInformation", label: "Personal Information" },
    { key: "locationDetails", label: "Location Details" },
    { key: "contactInformation", label: "Contact Information" },
    // { key: 'physicalAttributes', label: 'Physical Attributes' },
    { key: "professionalPreferences", label: "Professional Preferences" },
  ];

  if (talentData?.off_screen === 0) {
    tabs.splice(3, 0, {
      key: "physicalAttributes",
      label: "Physical Attributes",
    });
  }
  const RadioValueandLable = [
    { id: 1, title: "Yes" },
    { id: 0, title: "No" },
  ];
  const socialPlatforms = [
    "Facebook",
    "Instagram",
    "LinkedIn",
    "Threads",
    "Twitter-X",
    "TikTok",
    "YouTube",
  ];
  return {
    tabs,
    activeTab,
    setActiveTab,
    handleSubmit,
    onSubmit,
    control,
    errors,
    register,
    setValue,
    talentData,
    dropdowns,
    states,
    cities,
    desiredJobType,
    socialPlatforms,
    RadioValueandLable,
    links,
    linksErrors,
    selectedPlatform,
    setSelectedPlatform,
    addLink,
    updateLink,
    removeLink,
    setCountryCode,
    setCca2,
    otherLanguageId,
    otherExperienceId,
    isLoading,
    isLoadingprefilled,
    isLoadingStates,
    citiesisLoading,
    desiredJobTypeIsloading,
    loadingToapi,
    navigate,
    TextWeight,
  };
};
